module.exports = __webpack_public_path__ + "static/media/LH_Block.39b7b505.jpg";